import React, { useMemo, useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Carousel, Pagination } from 'app/components';
import { getPaginateData } from 'app/components/Pagination/utils';
import { FullSlider, SectionFour, SectionFive, DivSet4, SectionPagination, Events } from './styles';
import Box from './Box';
import BoxSlider from './BoxSlider';

const propTypes = {
  competitionList: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  eventList: PropTypes.oneOfType([PropTypes.array, PropTypes.any])
};

const defaultProps = {
  competitionList: [],
  eventList: []
};

const CompetitionInfo = ({ competitionList, eventList }) => {
  const [t] = useTranslation();

  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    centerMode: true,
    centerMargin: '20px',
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 3
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 2
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });

  const sliderRef = useRef(null);
  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  const [competitionData, setCompetitionData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(6);

  useEffect(() => {
    if (competitionList?.length) setCompetitionData(competitionList);
  }, [competitionList]);

  useEffect(() => {
    if (competitionList?.length) {
      const data = getPaginateData(competitionList, offset, limit);

      setPaginationData(data.data);
    }
  }, [offset, limit, competitionList]);

  return (
    <div className="cinema-rent__technic-concession-wrapper">
      <div className="cinema-rent__technic-wrapper">
        <SectionFour>
          {paginationData?.map(item => (
            <DivSet4 key={item?.id}>
              <Box item={item} />
            </DivSet4>
          ))}
        </SectionFour>
        <SectionPagination>
          {paginationData.length > limit &&
            <Pagination
              total={competitionData?.length}
              offset={offset}
              setOffset={setOffset}
              limit={limit}
              setLimit={setLimit}
            />
          }
        </SectionPagination>
        <SectionFive>
          {eventList?.length > 0 && (
            <FullSlider>
               <Events> {t("common.event_title")}</Events>
              <Carousel
                {...sliderProps}
                refEl={sliderRef}
                className="cinema-rent__carousel giftCardSliderData"
              >
                {eventList?.map((item, key)=> <BoxSlider key={key} item={item} />)}
              </Carousel>
            </FullSlider>
          )}
        </SectionFive>
      </div>
    </div>
  );
};

CompetitionInfo.propTypes = propTypes;
CompetitionInfo.defaultProps = defaultProps;

export default CompetitionInfo;
